function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#7F63FF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.87 20.35H3.13L0 31.3h36l-3.13-10.95zm-21.13 7.82l.78-3.17h11l.78 3.13-12.56.04z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M12.52 25.04l-.78 3.13h12.52l-.78-3.13zM0 31.3v.78a2.35 2.35 0 002.35 2.35h31.3A2.35 2.35 0 0036 32.09v-.79H0zM30.52 0h-25a2.35 2.35 0 00-2.39 2.35v18h29.74v-18A2.35 2.35 0 0030.52 0zm-.78 17.22H6.26V3.13h23.48v14.09z"
}));

function SvgAdminLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 36 35"
  }, props), _ref);
}

export default __webpack_public_path__ + "236c2ac3c11dbbc4edaac716de81f9d7.svg";
export { SvgAdminLaptop as ReactComponent };